import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import asscentsLogo from "../../assets/asscentsLogo.png";
import back from "../../assets/back.svg";
import { termsCondition } from "../../redux/actions/commonActions";

const TermsCondition = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [termsData, setTermsData] = useState("");

  useEffect(() => {
    dispatch(termsCondition(onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setTermsData(data.data.data);
    console.log(data.data.data);
  };

  const onError = (err) => {
    console.log(err);
  };
  return (
    <div className="static-body-container">
      <div className="w-100 static-top-nav">
        <div className=" ">
          <img src={asscentsLogo} alt="Asscents Logo" className="svgAsscents" />
        </div>
      </div>
      <div
        className="d-flex p-2 ms-3 m-1 mb-2 cursor_pointer"
        onClick={() => navigate(-1)}
      >
        <img src={back} alt="back_btn" />
        <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
          BACK
        </span>
      </div>
      <div className="d-flex justify-content-center align-items-center m-2 fn_Nunito ">
        <div className="static-main-container text-center mx-2 p-4">
          <p className="fs_38">Terms and Conditions</p>
          <p
            className="color_747f9e w-100 static-text"
            dangerouslySetInnerHTML={{ __html: termsData?.terms }}
          ></p>
        </div>
      </div>
    </div>
  );
};

export default TermsCondition;
